import deepEqual from 'deep-equal';

// Using deep-equal instead of lodash's isEqual because lodash's isEqual crashes is some cases.
// Crash reproduction - Firefox -> navigate between policy pages & tabs.
const isEqual = (a, b) => deepEqual(a, b, { strict: true });

// Deep comparison between two values.
// See https://lodash.com/docs/4.17.15#isEqual
export { isEqual };
